module.exports = __webpack_public_path__ + "static/media/titre_jeux_video.99c90bf7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Element/img/titre_jeux_video.png
// module id = 275
// module chunks = 0